import FloatingDecor from "@/components/shared/FloatingDecor";

// Reusable header band for inner pages.
export default function PageHero({ eyebrow, title, subtitle, children, tone = "sky" }) {
  const toneBg =
    tone === "navy"
      ? "bg-[#082B66] text-white"
      : tone === "yellow"
      ? "bg-gradient-to-br from-[#FFF4CC] via-[#FFFCF5] to-[#E8F5FF] text-[#082B66]"
      : "bg-gradient-to-br from-[#E8F5FF] via-[#FFFCF5] to-[#E8F5FF] text-[#082B66]";

  return (
    <section className={`relative overflow-hidden ${toneBg}`}>
      <FloatingDecor />
      <div className="relative mx-auto max-w-7xl px-4 py-14 sm:px-6 sm:py-20 lg:px-8">
        {eyebrow && (
          <span className="inline-flex items-center gap-2 rounded-full bg-white/70 px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-[#147DEB] ring-1 ring-[#147DEB]/10">
            {eyebrow}
          </span>
        )}
        <h1 className="font-display mt-4 text-4xl font-extrabold leading-tight tracking-tight sm:text-5xl lg:text-6xl">
          {title}
        </h1>
        {subtitle && <p className="mt-4 max-w-2xl text-base leading-relaxed opacity-90 sm:text-lg">{subtitle}</p>}
        {children}
      </div>
    </section>
  );
}
